import Api from '../api';

const CompetitorAPI = {
  getByAlias(alias) {
    return Api.get(`/competitors/${alias}`);
  },
  async getAllCompetitors(params) {
    return Api.get(`/competitors/all?`, {params});
  },
  updateCurrent(data) {
    return Api.put('/competitors/update-current', { data });
  }
};

export default CompetitorAPI;
